import React from "react";
import EditEklokReleyContainer from "../../containers/ekloks/EditEklokReleyContainer";
import EditEklokReleyForm from "../../forms/eklok/EditEklokReleyForm";
import { useTranslation } from "react-i18next";
import { Typography, Box, Divider } from "@material-ui/core";

const Edit = ({ reley, eklok, onRefresh = () => {} }) => {
  const { t } = useTranslation();

  return (
    <>
      <Divider />
      <Box my={1}>
        <Typography variant="h5">{t("edit_eklok_reley.title")}</Typography>
      </Box>
      <Box mb={1}>
        <EditEklokReleyContainer
          onRefresh={onRefresh}
          reley={reley}
          eklok={eklok}
        >
          {({ onSubmit, reley }) => (
            <EditEklokReleyForm onSubmit={onSubmit} reley={reley} />
          )}
        </EditEklokReleyContainer>
      </Box>
      <Divider />
    </>
  );
};

export default Edit;
